<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('SeaExport.PendingPickingOrder')" name="tabPending" :lazy="true">
          <tab-pending @print="onListPrintHandler" />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.PickingList')" name="tabPickingList" :lazy="true">
          <tab-picking-list @print="onListPrintHandler" />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.WarehouseReleaseReceipt')" name="tabWarehouseRelease" :lazy="true">
          <tab-warehouse-release @print="onListPrintHandler" />
        </el-tab-pane>
      </el-tabs>
    </div>

    <print-data-dialog
      ref="printDataDialog"
      :v-if="printDataDialog.visible"
      :visible.sync="printDataDialog.visible"
      :row="printDataDialog.row"
      :print-params="printDataDialog.printParams"
      @close="printDataDialog.visible=false"
      @printDataHandler="printDataHandler"
      @refresh="() => {}"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import tabPending from '@/views/cargo/v0/AirExport/PreWarehouseOutbound/components/tabPending.vue'
import tabPickingList from '@/views/cargo/v0/AirExport/PreWarehouseOutbound/components/tabPickingList.vue'
import tabWarehouseRelease from '@/views/cargo/v0/AirExport/PreWarehouseOutbound/components/tabWarehouseRelease.vue'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog.vue'
import PrintDataDialog from '@/components/Cargo/FrontEndWarehouse/components/warehouseHome/printDataDialog.vue'
import { WarehousingContext } from '@/components/Cargo/FrontEndWarehouse/components/warehousing/warehousingContext'

export default {
  name: 'PreWarehouseOutbound',
  components: { cargoTemplateSelectorDialog, PrintDataDialog, tabWarehouseRelease, tabPickingList, tabPending },
  data() {
    return {
      activeTabName: 'tabPending',
      context: WarehousingContext.getInstance(),
      templateSelectorDialog: {
        visible: false,
        category: '',
        data: {}
      },
      printDataDialog: {
        visible: false,
        row: null,
        printParams: null
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null
    }
  },
  methods: {
    // 列表打印
    onListPrintHandler(infokeys, pickingOrderKeys = null) {
      if (!infokeys || infokeys.length === 0) {
        return
      }
      const params = {
        WAREHOUSE_UUID: infokeys,
        PICKING_ORDER_UUID: pickingOrderKeys,
        category: 'WAREHOUSE',
        USER_ID: this.context.user.userId
      }
      if (!params) return
      this.templateSelectorDialog.category = 'WAREHOUSE'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    printDataHandler(printParams) {
      if (!printParams) {
        return
      }
      this.templateSelectorDialog.category = 'WAREHOUSE'
      this.templateSelectorDialog.data = printParams
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>

<style scoped>

</style>
